import Page from "components/base/Page";
import PlanList from "./PlanList";

const HandledPlanList = () => {
  return (
    <Page title="Handled Plans" backTo="./..">
      <PlanList handled />
    </Page>
  );
};

export default HandledPlanList;
